import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCopy = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_892_18408",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 24,
		height: 24,
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_892_18408)",
		children: /* @__PURE__ */ _jsx("path", { d: "M5.75006 21.3078C5.24494 21.3078 4.81738 21.1328 4.46738 20.7828C4.11738 20.4328 3.94238 20.0052 3.94238 19.5001V6.80786H5.44236V19.5001C5.44236 19.577 5.47441 19.6475 5.53851 19.7116C5.60261 19.7757 5.67312 19.8078 5.75006 19.8078H15.4423V21.3078H5.75006ZM9.25003 17.8078C8.7449 17.8078 8.31733 17.6328 7.96733 17.2828C7.61735 16.9328 7.44236 16.5052 7.44236 16.0001V4.61554C7.44236 4.11042 7.61735 3.68286 7.96733 3.33286C8.31733 2.98286 8.7449 2.80786 9.25003 2.80786H17.6346C18.1397 2.80786 18.5673 2.98286 18.9173 3.33286C19.2673 3.68286 19.4423 4.11042 19.4423 4.61554V16.0001C19.4423 16.5052 19.2673 16.9328 18.9173 17.2828C18.5673 17.6328 18.1397 17.8078 17.6346 17.8078H9.25003ZM9.25003 16.3078H17.6346C17.7115 16.3078 17.782 16.2758 17.8462 16.2117C17.9103 16.1476 17.9423 16.077 17.9423 16.0001V4.61554C17.9423 4.5386 17.9103 4.46809 17.8462 4.40399C17.782 4.33989 17.7115 4.30784 17.6346 4.30784H9.25003C9.1731 4.30784 9.10258 4.33989 9.03848 4.40399C8.97437 4.46809 8.94231 4.5386 8.94231 4.61554V16.0001C8.94231 16.077 8.97437 16.1476 9.03848 16.2117C9.10258 16.2758 9.1731 16.3078 9.25003 16.3078Z" })
	})]
});
export default SvgCopy;
